__turbopack_context__.v({
  "blogCoverImage": "strapiBlog-module-scss-module__PbxJ8W__blogCoverImage",
  "blogDescription": "strapiBlog-module-scss-module__PbxJ8W__blogDescription",
  "blogHeader": "strapiBlog-module-scss-module__PbxJ8W__blogHeader",
  "blogHeaderContent": "strapiBlog-module-scss-module__PbxJ8W__blogHeaderContent",
  "content": "strapiBlog-module-scss-module__PbxJ8W__content",
  "strapiBlog": "strapiBlog-module-scss-module__PbxJ8W__strapiBlog",
  "tableScroll": "strapiBlog-module-scss-module__PbxJ8W__tableScroll",
  "title": "strapiBlog-module-scss-module__PbxJ8W__title",
});
